import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ParametrosService } from '../../../../../services/parametros.service';
import { Grupo, Subgrupo } from '../../../../../models/parametros.model';

@Component({
  selector: 'app-subgrupo-manutencao',
  imports: [CommonModule, FormsModule],
  templateUrl: './subgrupo-manutencao.component.html',
  styleUrl: './subgrupo-manutencao.component.css',
  standalone: true,
})
export class SubgrupoManutencaoComponent implements OnInit {
  subgrupo: Subgrupo = { id: 0, nome: '', grupo: { id: 0, nome: '', createdAt: '' }, createdAt: '' };
  grupos: Grupo[] = [];
  subgrupoId: number | null = null;
  isEditMode = false;


  constructor(
    private parametrosService: ParametrosService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadGrupos();
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      if (id) {
        this.isEditMode = true;
        this.subgrupoId = +id;
        this.loadSubgrupo(this.subgrupoId);
      }
    });
  }
  
  loadGrupos(): void {
    this.parametrosService.getGrupos().subscribe(data => {
      this.grupos = data;
    });
  }

  loadSubgrupo(id: number): void {
    this.parametrosService.getSubgrupo(id).subscribe(data => {
      this.subgrupo = data;
    });
  }

  save(): void {
    if (this.subgrupoId) {
      this.parametrosService.updateSubgrupo(this.subgrupo).subscribe(() => {
        this.router.navigate(['/home/parametro-despesa-subgrupo']);
      });
    } else {
      this.parametrosService.createSubgrupo(this.subgrupo).subscribe(() => {
        this.router.navigate(['/home/parametro-despesa-subgrupo']);
      });
    }
  }

  cancel(): void {
    this.router.navigate(['/home/parametro-despesa-subgrupo']);
  }
}
